export default "__VITE_ASSET__B8WQW$ES__"